export const getCurrentPathWithoutLastPart = path => {
  const pathRgx = /\//g;
  const childroutecount = ((path || '').match(pathRgx) || []).length;
  return childroutecount > 1 ? path.slice(0, path.lastIndexOf('/')) : path;
};
